import { render, staticRenderFns } from "./B2BIcon.vue?vue&type=template&id=bc2104de&scoped=true"
import script from "./B2BIcon.vue?vue&type=script&lang=js"
export * from "./B2BIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2104de",
  null
  
)

export default component.exports